RivalIQ.apps.Insights.module('models', function (models, App, Backbone, Marionette, $, _) {

    'use strict';

    models.PostDetail = models.Post.extend({
        url: function () {
            const me = this;

            let queryParams = '';
            if (me.landscapeId) {
                queryParams = `?landscapeId=${me.landscapeId}`;
            }

            return `/api/company/${me.companyId}/insights/${me.channel}/${me.objectType}s/${me.postId}${queryParams}`;
        }
    });

});
